import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { CheckCircleFilled, FileTextOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
	.ant-modal-body {
		padding: 24px;
	}
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 24px;
`;

const Title = styled.div`
	font-size: 22px;
	font-weight: 700;
	color: #1e293b;
`;

const SummaryBox = styled.div`
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	padding: 20px 24px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;
`;

const Label = styled.div`
	font-size: 16px;
	color: #1f2937;
	margin-bottom: 4px;
`;

const Value = styled.div`
	font-size: 14px;
	color: #64748b;
	text-transform: uppercase;
`;

const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 28px;
	border-top: 1px solid #e5e7eb;
	padding-top: 16px;
`;

const ContinueButton = styled(Button)`
	height: 40px;
	padding: 0 32px;
	background-color: #1e3a5f;
	border-color: #1e3a5f;
	color: #fff;
	border-radius: 6px;

	&:hover,
	&:focus {
		background-color: #18405d !important;
		border-color: #18405d !important;
		color: #fff !important;
	}
`;

const formatCurrency = (value) => {
	if (value == null || value === '') return '-';
	const num = Number(value);
	return Number.isNaN(num) ? value : `₹ ${num.toLocaleString('en-IN')}`;
};

function InvoiceSuccessModal({ visible, summary, onDownload, onContinue, title }) {
	return (
		<StyledModal open={visible} onCancel={onContinue} footer={null} width={520} closable>
			<Header>
				<CheckCircleFilled style={{ color: '#22c55e', fontSize: 28 }} />
				<Title>{title}</Title>
			</Header>

			<SummaryBox>
				<div>
					<Label>Client</Label>
					<Value>{summary?.client || '-'}</Value>
				</div>
				<div>
					<Label>Project</Label>
					<Value>{summary?.project || '-'}</Value>
				</div>
				<div>
					<Label>Total Amount</Label>
					<Value>{formatCurrency(summary?.total)}</Value>
				</div>
				<div>
					<Label>Due Date</Label>
					<Value>{summary?.dueDate || '-'}</Value>
				</div>
			</SummaryBox>

			<Footer>
				<Button
					style={{ height: 40, padding: '0 20px', borderRadius: 6 }}
					icon={<FileTextOutlined />}
					onClick={onDownload}
				>
					Download PDF
				</Button>
				<ContinueButton onClick={onContinue}>Continue</ContinueButton>
			</Footer>
		</StyledModal>
	);
}

InvoiceSuccessModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	summary: PropTypes.shape({
		client: PropTypes.string,
		project: PropTypes.string,
		total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		dueDate: PropTypes.string,
	}),
	onDownload: PropTypes.func.isRequired,
	onContinue: PropTypes.func.isRequired,
	title: PropTypes.string,
};

InvoiceSuccessModal.defaultProps = {
	summary: {},
	title: 'Invoice Generated Successfully',
};

export default InvoiceSuccessModal;
